import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import Plugin from '@jbrowse/core/Plugin';
import BigBedAdapterF from './BigBedAdapter';
import BedpeAdapterF from './BedpeAdapter';
import BedTabixAdapterF from './BedTabixAdapter';
import BedAdapterF from './BedAdapter';
import { getFileName, makeIndex, makeIndexType } from '@jbrowse/core/util/tracks';
var BedPlugin = /*#__PURE__*/function (_Plugin) {
  _inherits(BedPlugin, _Plugin);
  function BedPlugin() {
    var _this;
    _classCallCheck(this, BedPlugin);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(BedPlugin).apply(this, arguments));
    _this.name = 'BedPlugin';
    return _this;
  }
  _createClass(BedPlugin, [{
    key: "install",
    value: function install(pluginManager) {
      BigBedAdapterF(pluginManager);
      BedAdapterF(pluginManager);
      BedpeAdapterF(pluginManager);
      BedTabixAdapterF(pluginManager);
      pluginManager.addToExtensionPoint('Core-guessAdapterForLocation', function (adapterGuesser) {
        return function (file, index, adapterHint) {
          var regexGuess = /\.(bb|bigbed)$/i;
          var adapterName = 'BigBedAdapter';
          var fileName = getFileName(file);
          var obj = {
            type: adapterName,
            bigBedLocation: file
          };
          if (regexGuess.test(fileName) && !adapterHint) {
            return obj;
          } else if (adapterHint === adapterName) {
            return obj;
          }
          return adapterGuesser(file, index, adapterHint);
        };
      });
      pluginManager.addToExtensionPoint('Core-guessAdapterForLocation', function (adapterGuesser) {
        return function (file, index, adapterHint) {
          var regexGuess = /\.bedpe\.gz$/i;
          var adapterName = 'BedpeAdapter';
          var fileName = getFileName(file);
          if (regexGuess.test(fileName) || adapterHint === adapterName) {
            return {
              type: adapterName,
              bedpeLocation: file
            };
          }
          return adapterGuesser(file, index, adapterHint);
        };
      });
      pluginManager.addToExtensionPoint('Core-guessAdapterForLocation', function (adapterGuesser) {
        return function (file, index, adapterHint) {
          var regexGuess = /\.bed\.b?gz$/i;
          var adapterName = 'BedTabixAdapter';
          var fileName = getFileName(file);
          var indexName = index && getFileName(index);
          if (regexGuess.test(fileName) || adapterHint === adapterName) {
            return {
              type: adapterName,
              bedGzLocation: file,
              index: {
                location: index || makeIndex(file, '.tbi'),
                indexType: makeIndexType(indexName, 'CSI', 'TBI')
              }
            };
          }
          return adapterGuesser(file, index, adapterHint);
        };
      });
      pluginManager.addToExtensionPoint('Core-guessAdapterForLocation', function (adapterGuesser) {
        return function (file, index, adapterHint) {
          var regexGuess = /\.bed$/i;
          var adapterName = 'BedAdapter';
          var fileName = getFileName(file);
          if (regexGuess.test(fileName) || adapterHint === adapterName) {
            return {
              type: adapterName,
              bedLocation: file
            };
          }
          return adapterGuesser(file, index, adapterHint);
        };
      });
    }
  }]);
  return BedPlugin;
}(Plugin);
export { BedPlugin as default };